import { io, type Socket } from 'socket.io-client'

let socket: Socket | null = null

export const getSocket = (): Socket => {
  if (!socket) {
    const url = import.meta.env.VITE_BACKEND_API_ENDPOINT || 'http://localhost:3333'
    socket = io(url, {
      autoConnect: true,
      forceNew: false,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10_000,
      rememberUpgrade: true,
      timeout: 60_000,
      transports: ['websocket', 'polling'],
      upgrade: true,
    })

    socket.on('connect_error', (error) => {
      console.error('❌ [WebSocket] Connection error:', error)
    })

    socket.on('reconnect_error', (error) => {
      console.error('❌ [WebSocket] Reconnection failed:', error)
    })
  }
  return socket
}
